import { render, staticRenderFns } from "./VMCHeader.vue?vue&type=template&id=01ce5f8c&scoped=true"
import script from "./VMCHeader.vue?vue&type=script&lang=js"
export * from "./VMCHeader.vue?vue&type=script&lang=js"
import style0 from "./VMCHeader.vue?vue&type=style&index=0&id=01ce5f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ce5f8c",
  null
  
)

export default component.exports